module.exports = __webpack_public_path__ + "img/2_de.fcefb73f.webp";